// extracted by mini-css-extract-plugin
module.exports =  {"navigation-arrow":"AkkrqWL","navigationArrow":"AkkrqWL","left-arrow":"jjVPe3p","leftArrow":"jjVPe3p","right-arrow":"HjDLwd4","rightArrow":"HjDLwd4"};